<template>
  <div class='newplace'>
    <img src="/static/images/activty/tradingrules/apptradingrules_01.png">
    <img src="/static/images/activty/tradingrules/apptradingrules_02.png">
    <img src="/static/images/activty/tradingrules/apptradingrules_03.png">
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace{
  width: 100%;
}
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/apptradingrules.vue